import { CustomerAuthInputField } from '../form-sections'
import type { CustomerAuthFieldUiHelpers } from '../form-sections'

type ForgotPasswordFormViewProps = {
  email: string
  submitting: boolean
  error: string
  loginHref: string
  submitCta: string
  submittingCta: string
  backToLoginLabel: string
  emailLabel: string
  emailPlaceholder: string
  fieldUi: CustomerAuthFieldUiHelpers
  onEmailChange: (value: string) => void
  onClearError: () => void
  onSubmit: () => Promise<void>
}

export const ForgotPasswordFormView = ({
  email,
  submitting,
  error,
  loginHref,
  submitCta,
  submittingCta,
  backToLoginLabel,
  emailLabel,
  emailPlaceholder,
  fieldUi,
  onEmailChange,
  onClearError,
  onSubmit,
}: ForgotPasswordFormViewProps) => (
  <form
    className="space-y-4"
    onSubmit={(event) => {
      event.preventDefault()
      void onSubmit()
    }}
  >
    <CustomerAuthInputField
      field="email"
      label={emailLabel}
      type="email"
      value={email}
      onChange={(value) => {
        onEmailChange(value)
        if (error) onClearError()
      }}
      placeholder={emailPlaceholder}
      autoComplete="email"
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      inputMode="email"
      required
      disabled={submitting}
      ui={fieldUi}
    />

    <button
      type="submit"
      disabled={submitting}
      className="ca-btn-primary inline-flex h-11 w-full items-center justify-center px-4 text-sm font-semibold shadow-[0_10px_24px_-18px_color-mix(in_srgb,var(--color-action-primary)_85%,transparent)] transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-60"
    >
      {submitting ? submittingCta : submitCta}
    </button>

    <a
      href={loginHref}
      className="inline-flex w-full items-center justify-center text-sm font-semibold text-(--color-focus-ring) underline decoration-[color-mix(in_srgb,var(--color-focus-ring)_35%,transparent)] underline-offset-4 transition-colors duration-150 hover:text-(--color-text-primary)"
    >
      {backToLoginLabel}
    </a>
  </form>
)
